import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  add: {
    id: 'manage-services.components.single-day-exceptions.add',
    defaultMessage: 'Add dates',
  },
  date: {
    id: 'manage-services.components.single-day-exceptions.date',
    defaultMessage: 'Date',
  },
  startTime: {
    id: 'manage-services.components.single-day-exceptions.start-time',
    defaultMessage: 'Start time',
  },
  endTime: {
    id: 'manage-services.components.single-day-exceptions.end-time',
    defaultMessage: 'End time',
  },
  available: {
    id: 'manage-services.components.single-day-exceptions.available',
    defaultMessage: 'Available',
  },
  unavailable: {
    id: 'manage-services.components.single-day-exceptions.unavailable',
    defaultMessage: 'Unavailable',
  },
  startTimePlaceholder: {
    id: 'manage-services.components.single-day-exceptions.start-time-placeholder',
    defaultMessage: 'Select start time',
  },
  endTimePlaceholder: {
    id: 'manage-services.components.single-day-exceptions.end-time-placeholder',
    defaultMessage: 'Select end time',
  },
  label: {
    id: 'manage-services.components.single-day-exceptions.label',
    defaultMessage: 'Availability exceptions',
  },
  description: {
    id: 'manage-services.components.single-day-exceptions.description',
    defaultMessage:
      'List any days and time windows when this practitioner is available or unavailable (outside of their normal availability schedule). Note: exceptions will override your recurring schedule. If your business is closed for holidays, maintenance or any other reason, you can set business closure dates in the <a>Business profile section</a>.',
  },
  descriptionField: {
    id: 'manage-services.components.single-day-exceptions.description-field',
    defaultMessage: 'Description',
  },
  startTimeAfterEndTime: {
    id: 'manage-services.components.single-day-exceptions.start-time-after-end-time',
    defaultMessage: 'Start time cannot be later than end time',
  },
  pastDate: {
    id: 'manage-services.components.single-day-exceptions.date-in-the-past',
    defaultMessage: 'Date cannot be in the past',
  },
  availabilityLabel: {
    id: 'manage-services.components.single-day-exceptions.availability-label',
    defaultMessage: 'Availability',
  },
});
